import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import OnboardPrompt from '../../Utils/Components/OnboardPrompt';

const useOnboardCheck = (isOnboarded) => {
  const navigate = useNavigate();

  const checkOnboarding = (path) => {
    if (isOnboarded) {
      navigate(path);
    } else {
      toast.error(<OnboardPrompt />, {
        position: toast.POSITION.TOP_LEFT,
        autoClose: true, // Keep the toast open until closed manually
        closeButton: true,
        hideProgressBar: false,
        draggable: false,
        closeOnClick: false,
        style: {
          minWidth: '600px',
        },
      });
    }
  };

  return checkOnboarding;
};

export default useOnboardCheck;
